import { render, staticRenderFns } from "./ResizeDetector.vue?vue&type=template&id=eddf4c26&scoped=true&"
import script from "./ResizeDetector.vue?vue&type=script&lang=js&"
export * from "./ResizeDetector.vue?vue&type=script&lang=js&"
import style0 from "./ResizeDetector.vue?vue&type=style&index=0&id=eddf4c26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eddf4c26",
  null
  
)

export default component.exports